import Image from "next/image";
import Link from "next/link";
import React from "react";

interface UseCaseBannerProps {
  block: any;
}

const UseCaseBanner: React.FC<UseCaseBannerProps> = ({ block }) => {
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;
  return (
    <>
      <section className="pb-[100px] md:pb-[210px] blog-banner bg-background-dark pt-[121px] md:pt-[155px] xl:pt-[175px]  relative z-0">
        {/* Shapes */}
        <div className="banner-shape-1 absolute top-[0px] left-0 z-[1] w-[50%] md:w-[40%]">
          <Image
            src="/images/banner-left-layer-mobile.png"
            alt="Banner Shape"
            width={571}
            height={571}
            className="w-full h-full md:hidden"
          />
          <Image
            src="/images/banner-left-layer-tablet.png"
            alt="Banner Shape"
            width={571}
            height={571}
            className="w-full h-full hidden md:block lg:hidden"
          />
          <Image
            src="/images/banner-left-layer-desktop.png"
            alt="Banner Shape"
            width={571}
            height={571}
            className="w-full h-full hidden lg:block"
          />
        </div>
        <div className="banner-shape-1 absolute bottom-0 right-0 z-[-1] ">
          <Image
            src="/images/banner-right-layer-mobile.png"
            alt="Banner Shape"
            width={471}
            height={471}
            className="object-cover w-full h-full md:hidden"
          />
          <Image
            src="/images/banner-right-layer-tablet.png"
            alt="Banner Shape"
            width={471}
            height={471}
            className="object-cover w-full h-full hidden md:block lg:hidden"
          />
          <Image
            src="/images/banner-right-layer-desktop.png"
            alt="Banner Shape"
            width={471}
            height={471}
            className="object-cover w-full h-full hidden lg:block"
          />
        </div>
        <div className="container">
          <span className=" text-gray-300 font-regular text-subtitle-4 md:mb-[32px] mb-[16px] block text-center">
            <span>
              <Link href="/use-cases" className="text-gray-300">
                Insights / Use-Cases{" "}
              </Link>
              <Link
                href={block.slug ? `/use-cases/${block?.slug}` : "#"}
                className="text-gray-300"
              >
                / Use-Case Details
              </Link>
            </span>
          </span>
          <div className="blog-heading mb-[32px] max-w-[1280px] mx-auto">
            <h2 className="text-center text-white font-bold  text-heading-2 md:mb-[12px] mb-[24px]">
              {block?.title || "Use Case Title Here"}
            </h2>
            <p className="text-gray-50 text-center font-regular text-subtitle-3 mb-[12px] md:mb-[12px]">
              {block?.publish_at
                ? new Date(block?.publish_at)?.toDateString()
                : ""}
            </p>
          </div>
        </div>
      </section>

      <div className="md:mt-[-200px] mt-[-100px] relative z-1 xl:pb-[80px] lg:pb-[70px] pb-[56px]">
        <div className="container">
          {block?.image?.data?.attributes?.url && (
            <Image
              quality={100}
              sizes="100vw"
              width={1230 * 2}
              height={420 * 2}
              alt="blog detail image"
              src={`${baseUrl}${block?.image?.data?.attributes?.url}`}
              className="object-cover w-full md:h-[420px] h-[220px]"
            />
          )}
        </div>
      </div>
    </>
  );
};

export default UseCaseBanner;
